import type { FC, PropsWithChildren } from 'react';
import { useCallback } from 'react';

import ModalDialog from '@trend-dev/trendtech-ui/components/UI/Modal/ModalDialog';

import { useDeviceWidth } from 'hooks/useDeviceWidth';

import { useTimerPopupContext } from '../Context';

const Dialog: FC<PropsWithChildren> = ({ children }) => {
    const { anchor, isOpen, setAnchor } = useTimerPopupContext();
    const { isDesktop } = useDeviceWidth();

    const handleClose = useCallback(() => {
        setAnchor(undefined);
    }, []);

    return (
        <ModalDialog size='sm' kind='black' open={isOpen} author={isDesktop ? anchor : undefined} onAfterClose={handleClose}>
            {children}
        </ModalDialog>
    );
};

export default Dialog;
